//INITIAL FLOW
import * as types from "./actionTypes";

export const setPaymentInfo = (name, value) => ({
  type: types.SET_PAYMENT_INFO,
  payload: {name, value}
});

export const setCardInfo = (name, value) => ({
  type: types.SET_CARD_INFO,
  payload: {name, value}
});

export const setCardErrors = (cardErrors) => ({
  type: types.SET_CARD_ERRORS,
  payload: {cardErrors}
});

export const setShippingErrors = (shippingErrors) => ({
  type: types.SET_SHIPPING_ERRORS,
  payload: {shippingErrors}
});

export const setShippingInfo = (name, value) => ({
  type: types.SET_SHIPPING_INFO,
  payload: {name, value}
});

export const setBillingInfo = (name, value) => ({
  type: types.SET_BILLING_INFO,
  payload: {name, value}
});

export const restorePaymentInfo = (someValues) => ({
  type: types.RESTORE_PAYMENT_INFO,
  payload: someValues
});
